export const DEFAULT_ACTION_COLOR = '#1976D2FF'; // $primary-color
export const INTERNAL_ACTION_COLOR = '#0D47A1FF'; // $glxy-blue-900
export const BUILDING_BLOCK_ACTION_COLOR = '#6775C3';
